
import Vue from 'vue'
export default Vue.extend({
   name: 'ToolbarActionButton',
   props: {
      label: { default: '', type: String },
      showIcon: { default: true, type: Boolean },
      icon: { default: '', type: String },
      enabled: { default: true, type: Boolean },
   },
   computed: {},
   methods: {
      onClick() {
         if (this.enabled) {
            this.$emit('click')
         }
      },
   },
})
